// extracted by mini-css-extract-plugin
export default {"firstColumn":"rank-rewards_firstColumn__McxUe"};